import {FEEDBACK_DATA_SUCCESS} from "../constants/AuthConstant.js"

export const FeedbackSuccessAction = (interviewData) => {
    return {
      type: FEEDBACK_DATA_SUCCESS,
    payload: interviewData,

    };
  };


